import React from 'react'
import PropTypes from 'prop-types'
import hoc from '@hoc'

class Error403 extends React.Component {
    render() {
        const { classes } = this.props

        return (
            <div className={`${classes.container} middle-box p-15 animated fadeInUp`}>
                <h1>{this.props.ip}</h1>
                <h3 className="font-bold">Forbidden:IP Address Rejected</h3>
                <div className="error-desc">Access Denied. You Do Not Have The Permission To Access This Page On This Server</div>
            </div>
        )
    }
}

const styles = () => ({
    container: {
        padding: '15px'
    }
})

Error403.propTypes = {
    classes: PropTypes.object,
    ip: PropTypes.string
}

export default hoc(styles)(Error403)
